export type QueryValue = string | number | boolean | null | undefined | (string | number)[];
export type QueryParams = Record<string, QueryValue>;

export function buildQuery(params: Record<string, unknown> | undefined): string {
  if (!params) return '';
  const out = new URLSearchParams();
  for (const [key, value] of Object.entries(params) as [string, QueryValue][]) {
    if (value === undefined || value === null) continue;
    if (Array.isArray(value)) {
      for (const v of value) {
        out.append(key, String(v));
      }
    } else {
      out.append(key, String(value));
    }
  }
  const s = out.toString();
  return s ? `?${s}` : '';
}
